export default "__VITE_ASSET__DoPFj35$__"